import { ApiResult } from "./ApiResult";
import { api } from "./Api";
import { RequestBuscarTodasComprasPorUsuarioCompleto } from "@/dtos/Request/RequestBuscarTodasComprasPorUsuarioCompleto";
import { RequestBuscarExtrato } from "@/dtos/Request/RequestBuscarExtrato";
import { DadosCompraCartaoCreditoDto, DadosCompraPixDto, DadosCompraSaldoDto, DadosInserirCreditos } from "@/dtos/Request/RequestDadosCompraCartaoCreditoDto";
import { QrCodeGeradoDto } from "@/dtos/QrCodeGeradoDto";
import { EncryptData } from "@/utils/EncryptData";
import { CompraUsuarioDto } from "@/dtos/CompraUsuarioDto";

class CompraService {

    async BuscarTodasComprasPorUsuarioCompleto(token: string | null) {
        let config = token ? { headers: { Authorization: token } } : undefined;
        let { data: result } = await api.get<ApiResult<RequestBuscarTodasComprasPorUsuarioCompleto>>("Compra/BuscarMinhasCompras", config);
        return result
    }

    async BuscaExtrato() {
        let { data: result } = await api.get<ApiResult<RequestBuscarExtrato>>("Compra/BuscarExtrato");
        return result;
    }

    async BuscarCompra(idCompra: number) {
        let { data: result } = await api.get<ApiResult<CompraUsuarioDto>>("Compra/BuscarCompra/" + idCompra);
        return result;
    }

    async VerificarCartaoCreditoHabilitado() {
        const { data: result } = await api.get<ApiResult<boolean>>('Compra/VerificarCartaoCreditoHabilitado');
        return result;
    }

    async FinalizarCompraCartaoCredito(dadosCompra: DadosCompraCartaoCreditoDto) {
        const dados = await EncryptData(dadosCompra);
        let { data: result } = await api.post<ApiResult<any>>("Compra/EfetuarPagamento", { dados });
        return result;
    }

    async FinalizarCompraSaldo(dadosCompra: DadosCompraSaldoDto) {
        const dados = await EncryptData(dadosCompra);
        let { data: result } = await api.post<ApiResult<any>>("Compra/EfetuarPagamento", { dados });
        return result;
    }

    async FinalizarCompraPix(dadosCompra: DadosCompraPixDto) {
        const dados = await EncryptData(dadosCompra);
        let { data: result } = await api.post<ApiResult<QrCodeGeradoDto>>("Compra/EfetuarPagamento", { dados });
        return result;
    }

    async InserirCreditos(dadosInserirCreditos: DadosInserirCreditos) {
        let { data: result } = await api.post<ApiResult<QrCodeGeradoDto>>("Compra/InserirCreditos", dadosInserirCreditos);
        return result;
    }

    async BuscarUltimoBoletoEmAberto() {
        let { data: result } = await api.get<ApiResult<QrCodeGeradoDto>>("Compra/BuscarUltimoBoletoEmAberto");
        return result;
    }

    async CancelarFatura(idFatura: string) {
        let { data: result } = await api.post<ApiResult<any>>("Compra/CancelarFatura", { IdFatura: idFatura });
        return result;
    }
}



export default new CompraService();